/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listMarketingMessages} from '../api'

export const useMutationListMarketingMessages = createReactQueryMutationHook('listMarketingMessages', listMarketingMessages)
